var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"transparent",attrs:{"flat":""}},[_c('Pits',{attrs:{"host":_vm.$apiHost(),"apiKey":_vm.$apiKey(),"credentials":_vm.credentials}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }